export const thebeConfigR = {
    requestKernel: true,
    binderOptions: {
        repo: "binder-examples/r-conda",
        ref: "master",
        savedSession: {
          enabled: true,
          // mybinder.org culls idle servers after roughly 10 minutes; a longer window
          // just means committing to a server that is already gone.
          maxAge: 600,
          storagePrefix: "thebe-binder-r-",
        }
    },
    codeMirrorConfig: {
        theme: "abcdef",
        mode: 'r', 
    },
    kernelOptions: {
        name: 'ir',
    }
};

export const thebeConfigPython = {
    requestKernel: true,
    binderOptions: {
        repo: "abhinab303/requirements-dslp",
        ref: "main",
        binderUrl: "https://mybinder.org",
        repoProvider: "github",
        savedSession: {
          enabled: true,
          // mybinder.org culls idle servers after roughly 10 minutes; a longer window
          // just means committing to a server that is already gone.
          maxAge: 600,
          storagePrefix: "thebe-binder-",
        }

    },
    codeMirrorConfig: {
        theme: "abcdef",
        mode: 'python',
    },
    kernelOptions: {
        name: 'python'
    }
};